import Image from 'next/image'

interface Props {
    products?: boolean
}

const InexistentSearch: React.FC<Props> = ({ products = false }) => {
    return (
        <div className="flex flex-col gap-12 2xl:px-[500px] px-[300px] py-[100px] max-md:py-[20px] max-lg:px-8 max-md:flex-col items-center justify-center max-md:mb-44">
            <Image src="/assets/icons/glofi_hand_orange.svg" height={166} width={150} alt="" />
            <div className="flex flex-col gap-6">
                <p className=" text-4xl max-md:text-3xl font-semibold text-black text-center">
                    Nenhum produto encontrado
                </p>
                <p>Tente realizar uma nova busca utilizando termos diferentes</p>
            </div>
            {products ? (
                // Recarga completa de propósito: limpa os filtros e a busca da listagem (como hoje).
                // eslint-disable-next-line @next/next/no-html-link-for-pages
                <a href="/produtos" className="uppercase text-lg text-orange flex gap-2 hover:underline">
                    <Image src="/assets/icons/orange-arrow-left.svg" height={17} width={20} alt="" />
                    Voltar para produtos
                </a>
            ) : null}
        </div>
    )
}

export default InexistentSearch
